import { Capacitor } from '@capacitor/core';
import { useAuthSession } from '@nbx/frontend-helpers/subscribe';
import { useRemoteFeatureFlag, useRemoteConfig } from '@nbx/config';

const FIREBASE_CONFIG = {
  featureFlag: 'markets_price_alerts_feature_flag',
  availableMarkets: 'markets_price_alerts_available_markets'
};

const useMarketsWithFeatureEnabled = () => {
  const { values } = useRemoteConfig();
  const value = values?.[FIREBASE_CONFIG.availableMarkets]?.asString();
  if (!value) {
    return new Set();
  }
  let markets = [];
  try {
    markets = JSON.parse(value);
  } catch (err) {
    console.error(`Failed parsing JSON for Remote Config `, err);
  }

  return new Set(markets);
};

export const useShowMarketAlertsToggle = ({ pair }) => {
  const [isFeatureEnabledForAccount] = useRemoteFeatureFlag(FIREBASE_CONFIG.featureFlag);
  const marketsWithFeatureEnabled = useMarketsWithFeatureEnabled();
  const session = useAuthSession();

  const isFeatureEnabledForMarket = marketsWithFeatureEnabled.has('*') || marketsWithFeatureEnabled.has(pair);
  return !!session && Capacitor.isNativePlatform() && isFeatureEnabledForAccount && isFeatureEnabledForMarket;
};
